module.exports = __webpack_public_path__ + "static/media/passat-estate.4dccfa17.png";